import { Moment } from "moment";

export const incrementOneDay = (last: Moment) => last.clone().add(1, "day");

export const incrementOneHour = (last: Moment) => last.clone().add(1, "hour");
